import { NormalizeFns } from '~/types';

export const useNormalizations = (normalizeFns: NormalizeFns): NormalizeFns => {
    const callbacks: NormalizeFns = {};

    for (const key in normalizeFns) {
        if (Object.prototype.hasOwnProperty.call(normalizeFns, key)) {
            callbacks[key] = (value: string, prevValue: string) => {
                const returnValue = normalizeFns[key](value, prevValue);
                return returnValue || '';
            };
        }
    }

    return callbacks;
};
